import React, {FC, forwardRef, useState} from 'react';

import {cn} from '@bem-react/classname';
import {StarFill} from '@gravity-ui/icons';
import {Popover} from '@gravity-ui/uikit';

import {StarsProps} from './Stars.types';

import './Stars.scss';

const cnStars = cn('Stars');

const STAR_SIZE = 41;

const Stars: FC<StarsProps> = forwardRef<HTMLDivElement, StarsProps>(function Stars(
    {defaultValue = '', ...props},
    ref,
) {
    const [checked, setCheked] = useState<number>(
        props.options?.map(({value}) => value).indexOf(props.value ?? defaultValue) ?? -1,
    );
    const [hovered, setHovered] = useState<number>(-1);

    return (
        <div>
            <div ref={ref} className={cnStars('Container')}>
                {props.options?.map(({value, content, label}, index) => (
                    <div className={cnStars('Item')} key={index}>
                        <Popover
                            content={content}
                            placement={'bottom'}
                            hasArrow={false}
                            tooltipContentClassName={cnStars('Tooltip')}
                            tooltipOffset={[0, 0]}
                        >
                            <div className={cnStars('Block')}>
                                <input
                                    aria-label={label}
                                    id={props.id + value}
                                    className={cnStars('Input')}
                                    type="radio"
                                    name={props.name}
                                    onChange={() => {
                                        setCheked(index);
                                        if (props.onUpdate) props.onUpdate(value);
                                    }}
                                />
                                <label htmlFor={props.id + value}>
                                    <StarFill
                                        focusable
                                        onClick={() => setCheked(index)}
                                        width={STAR_SIZE}
                                        height={STAR_SIZE}
                                        onMouseEnter={() => setHovered(index)}
                                        onMouseLeave={() => setHovered(-1)}
                                        className={cnStars('Star', {
                                            checked: index <= checked,
                                            nothovered: hovered >= 0 && index > hovered,
                                            hovered: index <= hovered,
                                        })}
                                        test-id={'test-id-star' + index}
                                    />
                                </label>
                            </div>
                        </Popover>
                    </div>
                ))}
            </div>
        </div>
    );
});

export default Stars;
